import { CaseLevel1Code, CaseLevel2Code } from 'shared/constants/common-cases';
import type { CaseLevel2Option } from 'shared/models/common-cases';

export default function getCaseLevels2BasedOnCaseLevel1(
  caseLevel1: CaseLevel1Code,
  caseLevels2: CaseLevel2Option[]
) {
  switch (caseLevel1) {
    case CaseLevel1Code.FlawNotification:
      return caseLevels2.filter(({ Value }) => {
        return [
          CaseLevel2Code.Heating,
          CaseLevel2Code.Water,
          CaseLevel2Code.Air,
          CaseLevel2Code.Electricity,
          CaseLevel2Code.Building,
          CaseLevel2Code.Machines,
          CaseLevel2Code.Outdoors,
          CaseLevel2Code.Indoors,
          CaseLevel2Code.WarrantyRepair,
          CaseLevel2Code.Other,
        ].includes(Value);
      });
    case CaseLevel1Code.Notification:
      return caseLevels2.filter(({ Value }) => {
        return [
          CaseLevel2Code.Reclamation,
          CaseLevel2Code.Disturbance,
          CaseLevel2Code.Other,
          CaseLevel2Code.Idea,
          CaseLevel2Code.ResidentChanges,
          CaseLevel2Code.MeterReadings,
        ].includes(Value);
      });
    case CaseLevel1Code.Inquiry:
      return caseLevels2.filter(({ Value }) => {
        return [
          CaseLevel2Code.Management,
          CaseLevel2Code.Board,
          CaseLevel2Code.Finance,
          CaseLevel2Code.Balance,
          CaseLevel2Code.Loans,
        ].includes(Value);
      });
    case CaseLevel1Code.Reservation:
      return caseLevels2.filter(({ Value }) => {
        return [
          CaseLevel2Code.ParkingLot,
          CaseLevel2Code.Garage,
          CaseLevel2Code.Sauna,
          CaseLevel2Code.OtherSpace,
        ].includes(Value);
      });
    default:
      return [];
  }
}
